<template>
    <div class="container">
      <b-card-group columns>
            <b-card v-for="(item, index) in articulo" :key="index" v-bind:id="index" :title="item.nombre_art" :img-src="'https://michi.controlador-aula.com/ima/'+item.nombre_ima">
            <router-link :to="'/articulo/'+item.id_art">
            <b-card-text >
              <div v-html="item.descripcionCor_art" style="font-family: Verdana, Geneva, Tahoma, sans-serif !important;">
              </div>
            </b-card-text>
            <template v-slot:footer>
                <small class="text-muted">Más información</small>
            </template>
            <b-button variant="danger" class="center">Más información</b-button>
            </router-link>
            </b-card>
        </b-card-group>
    </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      articulo: ''
    }
  },
  async created () {
    try {
      const res = await axios.get(`https://michi.controlador-aula.com/Connections/michi-jala-8695JA.php`)
      this.articulo = res.data
    } catch (error) {
      console.log(error)
      return { error }
    }
  }

}
</script>
<style>
.container {
  margin: 5 auto;
  min-height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
}
</style>
